import Parser from "ua-parser-js"

export function isMobile(userAgent: string | undefined) {
  let result

  if (userAgent) {
    result = Parser(userAgent || "")
  } else {
    result = new Parser().getResult()
  }

  return result?.device?.type === "mobile"
}
